import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { IdentityService } from './identity.service';
import { RETURN_URL_QUERY_PARAM } from './return-url';

/**
 * Admits a signed-in staff member; sends anyone else to the login page carrying the URL they asked
 * for — path AND query — so a deep link (`/customers/workers/{id}?country=RU`) survives the sign-in
 * instead of landing on the dashboard of whatever country was last active.
 */
export const authGuard: CanActivateFn = (_route, state) => {
    const identityService = inject(IdentityService);
    const router = inject(Router);

    return identityService.stateChanges.pipe(
        take(1),
        map(authState => {
            if (authState.user) {
                return true;
            }
            // The root needs no return URL: it is where a sign-in lands anyway.
            return state.url === '/'
                ? router.createUrlTree(['/login'])
                : router.createUrlTree(['/login'], { queryParams: { [RETURN_URL_QUERY_PARAM]: state.url } });
        }),
    );
};
